import { useCallback, useEffect, useState } from "react"
import { useUser } from "./useUser"
import { useResto } from "./useResto";
import { useHost } from "./userInfoService";
import { useTransaction } from "./useTransaction";
import { useChat } from "./useChat";
import { useRestoUsers } from "./useRestoUsers";
import { useEvaluation } from "./useEvaluations";

export const useLoad = () => {
    const { isHost, isResto, getAvatarUser, userId, isCEO } = useUser();
    const { getResto, resto } = useResto();
    const { getDataHost, infoHost } = useHost();
    const { getPoints, getRanking, getHostPosition } = useTransaction();
    const { lastMessage, refreshBeforeSend } = useChat();
    const [noti, setNoti] = useState(null);
    const { getAllRestoHost, hostResto } = useRestoUsers();
    const { getEvalByResto, restoEvaluation } = useEvaluation()

    useEffect(() => { getMessageAction(lastMessage) }, [lastMessage])

    const getMessageAction = (m) => {
        if (m?.type === "server" && m?.message?.action === "update-likes" && m?.message?.data?.workerId === userId) {
            getPoints();
        }

        refreshBeforeSend()
    }

    const loadByHost = useCallback(() => {
        getDataHost();
        getAvatarUser(infoHost?.cover, infoHost?.name);
        getRanking("resto");
        getHostPosition();
        getResto();
        getPoints();
        refreshBeforeSend();
    }, [infoHost])

    const loadByResto = useCallback(() => {
        if (!isCEO) {
            getAvatarUser(resto?.brand, resto?.name || "");
            getAllRestoHost();
            getEvalByResto();
            getResto();
            getPoints();
            refreshBeforeSend();
        }
    }, [resto, hostResto, restoEvaluation, getEvalByResto,])

    const loadByCEO = useCallback(() => {

    }, [])

    const load = useCallback(() => {
        if (isHost) loadByHost();
        if (isResto) loadByResto();
        if (isCEO) loadByCEO()
    }, [loadByCEO, loadByHost, loadByResto, isHost, isResto])

    const onNotification = useCallback(async (payload) => {
        const { data, notification } = payload;
        setNoti({ title: notification.title, message: notification.body, icon: data.icon });
        refreshBeforeSend();
    }, [noti, setNoti])

    return { load, onNotification, noti, setNoti }
}